module.exports = __webpack_public_path__ + "img/zszz-ic.c8eb3065.png";